const groupChatsByDate = (chats:any) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    
    const thirtyDaysAgo = new Date(today);
    thirtyDaysAgo.setDate(today.getDate() - 30);

    return {
      today: chats.filter((chat:any) => {
        const chatDate = new Date(chat.last_updated);
        chatDate.setHours(0, 0, 0, 0);
        return chatDate.getTime() === today.getTime();
      }),
      lastWeek: chats.filter((chat:any) => {
        const chatDate = new Date(chat.last_updated);
        chatDate.setHours(0, 0, 0, 0);
        return chatDate > sevenDaysAgo && chatDate < today;
      }),
      lastMonth: chats.filter((chat:any) => {
        const chatDate = new Date(chat.last_updated);
        chatDate.setHours(0, 0, 0, 0);
        return chatDate > thirtyDaysAgo && chatDate <= sevenDaysAgo;
      }),
      older: chats.filter((chat:any) => {
        const chatDate = new Date(chat.last_updated);
        chatDate.setHours(0, 0, 0, 0);
        return chatDate <= thirtyDaysAgo;
      })
    };
  };

export default groupChatsByDate;